import React, { useEffect, useState } from 'react'
import { Button, Typography } from '@mui/material'
import { deleteRequest } from 'utils/api'
import {
  CALENDER_OAUTH_TOKEN_URL
} from 'services/constants'
import LinkCalendarButton from 'components/molecules/oAuth/LinkCalendarButton'
import OverlayLoading from 'components/atoms/OverlayLoading'
import SuccessfulNotificationDialog from 'components/molecules/notificationOverlay/SuccessfulNotificationDialog'
import { getThirdPartyOauth } from 'services/userServices'
import { useTranslation } from 'react-i18next'
import { trackEvent } from 'services/amplitudeTracking'
import { ColStack } from 'components/atoms/container/InCardStack'
import ConnectedCalendarItem from 'components/molecules/oAuth/ConnectedCalendarItem'

const CalendarSettings = () => {
  const { t } = useTranslation()
  const [linked, setLinked] = useState(null)
  const [tokenExpired, setTokenExpired] = useState(false)
  const [tokenUnauthorized, setTokenUnauthorized] = useState(false)
  const [loading, setLoading] = useState(false)
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [provider, setProvider] = useState(null)
  const [email, setEmail] = useState('')

  const fetchData = async () => {
    const res = await getThirdPartyOauth()
    const resData = res?.data

    setLinked(res.linked)
    setTokenUnauthorized(res.status === 422)
    setTokenExpired(res.tokenInvalid)
    setProvider(resData?.provider ?? null)
    setEmail(resData?.email ?? '')
    setLoading(false)
  }

  const signinCallback = sucess => {
    setLinked(sucess)
    if (sucess) {
      setLoading(true)
      fetchData()
    }
  }

  useEffect(() => {
    setLoading(true)
    fetchData()
  }, [])

  const handleDisconnect = async () => {
    setLoading(true)
    const res = await deleteRequest(CALENDER_OAUTH_TOKEN_URL)
    if (res.status === 204) {
      setLinked(false)
      setEmail(null)
      setSuccessDialogOpen(true)
      trackEvent('Disconnect Calendar')
    }
    setLoading(false)
  }
  return (
    <ColStack spacing={12}>
      <Typography variant='h3'>{t('calendarEvents.calendar')}</Typography>
      {email ? (
        <>
          <Typography>{t('calendarEvents.connectedCalendar')}:</Typography>
          <ConnectedCalendarItem provider={provider} email={email} />
        </>
      ) : null}
      {linked === false ? (
        <>
          <Typography variant='body2'>
            {tokenExpired
              ? tokenUnauthorized
                ? t('calendarEvents.unableToConnectCalendarTryAgain')
                : t('calendarEvents.connectionExpired')
              : t('calendarEvents.linkingYourCalendar')}
          </Typography>
          <LinkCalendarButton signinCallback={signinCallback} />
        </>
      ) : linked === true ? (
        <>
          <Typography variant='body1Small' color='textSecondary'>
            {t('calendarEvents.IiDisconnectCalendar')}
          </Typography>
          <Button onClick={() => handleDisconnect()} color='muted'>
            {t('calendarEvents.disconnectCalendar')}
          </Button>
        </>
      ) : null}
      <OverlayLoading open={loading} />
      <SuccessfulNotificationDialog
        open={successDialogOpen}
        titleText={t('calendarEvents.requestDone')}
        notificationText={t('calendarEvents.youDisconnectedCalendar')}
        buttonAction={() => setSuccessDialogOpen(false)}
        confirmButtonText={t('common.done')}
      />
    </ColStack>
  )
}

export default CalendarSettings
